<div class="device-group-view">
  <form [formGroup]="form">
    <div class="mb-3 row">
      <div class="col-lg-3" [ngClass]="{'has-error':!groupName.valid}">
        <label>Group Name</label>
        <input type="text" class="form-control" [formControl]="groupName" />
        @if (groupName.hasError('required')) {
          <div class="alert alert-danger">Group Name is required</div>
        }
      </div>
      <div class="col-lg-2" [ngClass]="{'has-error':!groupType.valid}">
        <label>Group Type</label>
        <select class="form-control" [formControl]="groupType" (change)="onGroupTypeChange()">
          <option value="dynamic">Dynamic</option>
          <option value="static">Static</option>
        </select>
      </div>
    </div>
    <p-tabView [activeIndex]="activeIndex" (onChange)="onActiveIndexChange($event)">
      <p-tabPanel header="Primary Devices" [disabled]="groupTypeStr != 'dynamic'">
        <div class="mb-3 row" style="margin: 1px 0px 0px 0px;">
          <div class="col-lg-4" [ngClass]="{'has-error':!primBaseIncludeScope.valid}">
            <label>Primary Devices to Include</label>
            <select class="form-control" [formControl]="primBaseIncludeScope" (change)="updateFilterSummaries()">
              <option value="AllDevices">All Devices</option>
              <option value="AllSnmpDevices">SNMP Devices Only</option>
              <option value="AllNetworkDevices">Network Devices Only</option>
            </select>
          </div>
          <span class="col-lg-1"></span>
          <div class="col-lg-6" style="padding-left: 0px; padding-right: 0px;">
            <br />
            <button type="button" pButton class="device-button"
            (click)="onPreviewPrim()" label="Preview Primary Devices..."></button>
            <button type="button" pButton class="device-button"
            (click)="onCopyPrim()" label="Copy Device Filter..."></button>
          </div>
        </div>
        <div class="row" style="margin: 10px;">
            <p-tabView>
                <p-tabPanel header="Hosts" [selected]="true">
                    <div class="filter-tab" [ngClass]="{'has-error':!primNameFilters.valid}">
                        <label>Primary Device Host / System / NetBIOS Names (* and ? are wildcards)</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="primNameFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (primNameFilters.hasError('validNameFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid host/system name filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="IP Ranges">
                    <div class="filter-tab" [ngClass]="{'has-error':!primIpScopeFilters.valid}">
                        <label>Primary Device IP Addresses / Ranges / Subnets</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="primIpScopeFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (primIpScopeFilters.hasError('validIpScopeFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid IP range filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="VLANs">
                    <div class="filter-tab" [ngClass]="{'has-error':!primVlanFilters.valid}">
                        <label>Primary Device VLAN Names / Indexes (* and ? are wildcards)</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="primVlanFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (primVlanFilters.hasError('validVlanFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid VLAN filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="OIDs">
                    <div class="filter-tab" [ngClass]="{'has-error':!primOidFilters.valid}">
                        <label>Primary Device SNMP OIDs/Object Identifiers (* and ? are wildcards)</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="primOidFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (primOidFilters.hasError('validOidFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid OID filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Categories">
                    <div class="filter-tab">
                        <label>Primary Device Categories (all checked/unchecked = no filter)</label>
                        <div class="row">
                            <div class="col-lg-12">
                                <device-category-selector [(selection)]="primDeviceCategories" scrollHeight="100px"
                                                          (selectionChange)="onPrimCategoriesChange($event)">
                                </device-category-selector>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Open Ports">
                    <div class="filter-tab">
                        <label>Primary Devices with Open Ports ( comma seperated )</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="primPortFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (primPortFilters.hasError('validPortFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid Port filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
        <div style="margin: 10px;">
          <label>Primary Device Filter Summary</label>
          <div class="row" style="margin: 0px;">
            <textarea style="display: block; width: 550px;" rows="8" readonly>{{primFilterSummary}}</textarea>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Connected Devices" [disabled]="groupTypeStr != 'dynamic'">
        <div class="mb-3 row" style="margin: 1px 0px 0px 0px;">
          <div class="col-lg-4" [ngClass]="{'has-error':!connBaseIncludeScope.valid}">
            <label>Connected Devices to Include</label>
            <select class="form-control" [formControl]="connBaseIncludeScope" (change)="updateFilterSummaries()">
              <option value="NoDevices">No Devices</option>
              <option value="AllDevices">All Devices</option>
              <option value="AllSnmpDevices">SNMP Devices Only</option>
              <option value="AllNetworkDevices">Network Devices Only</option>
            </select>
          </div>
          <span class="col-lg-1"></span>
          <div class="col-lg-6" style="padding-left: 0px; padding-right: 0px;">
            <br />
            <button type="button" pButton class="device-button"
            (click)="onPreviewConn()" label="Preview Connected Devices..."></button>
            <button type="button" pButton class="device-button"
            (click)="onCopyConn()" label="Copy Device Filter..."></button>
          </div>
        </div>
        <div class="row" style="margin: 10px;">
            <p-tabView>
                <p-tabPanel header="Hosts" [selected]="true">
                    <div class="filter-tab" [ngClass]="{'has-error':!connNameFilters.valid}">
                        <label>Connected Device Host / System / NetBIOS Names (* and ? are wildcards)</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="connNameFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (connNameFilters.hasError('validNameFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid host/system name filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="IP Ranges">
                    <div class="filter-tab" [ngClass]="{'has-error':!connIpScopeFilters.valid}">
                        <label>Connected Device IP Addresses / Ranges / Subnets</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="connIpScopeFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (connIpScopeFilters.hasError('validIpScopeFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid IP range filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="VLANs">
                    <div class="filter-tab" [ngClass]="{'has-error':!connVlanFilters.valid}">
                        <label>Connected Device VLAN Names / Indexes (* and ? are wildcards)</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="connVlanFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (connVlanFilters.hasError('validVlanFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid VLAN filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="OIDs">
                    <div class="filter-tab" [ngClass]="{'has-error':!connOidFilters.valid}">
                        <label>Connected Device SNMP OIDs/Object Identifiers (* and ? are wildcards)</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="connOidFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (connOidFilters.hasError('validOidFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid OID filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Categories">
                    <div class="filter-tab">
                        <label>Connected Device Categories (all checked/unchecked = no filter)</label>
                        <div class="row">
                            <div class="col-lg-12">
                                <device-category-selector [(selection)]="connDeviceCategories" scrollHeight="100px"
                                                          (selectionChange)="onConnCategoriesChange($event)">
                                </device-category-selector>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Open Ports">
                    <div class="filter-tab" [ngClass]="{'has-error':!connPortFilters.valid}">
                        <label>Connected Device with Open Ports ( comma seperated )</label>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            <textarea rows="6" class="col-lg-12" [formControl]="connPortFilters" (input)="updateFilterSummaries()"></textarea>
                        </div>
                        <div class="row" style="margin: 0px 10px 0px 5px;">
                            @if (connPortFilters.hasError('validPortFilters')) {
                            <div class="col-lg-12 alert alert-danger">Invalid Port filters</div>
                            }
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
        <div style="margin: 10px;">
          <label>Connected Device Filter Summary</label>
          <div class="row" style="margin: 0px;">
            <textarea style="display: block; width: 550px;" rows="8" readonly>{{connFilterSummary}}</textarea>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Add/Remove Devices" [disabled]="groupTypeStr != 'static'">

        <p style="margin-top: 5px; margin-bottom: 5px;">
          Total Devices: {{entries.length}}
        </p>

        <div class="row" style="margin: 0px;">
          <div style="width: 84%;">
            <p-table class="member-devices-table" [value]="entries" [rows]="12"
              [scrollable]="true" scrollHeight="500px" dataKey="dataKey"
              selectionMode="multiple" [(selection)]="selectedDeviceGroupMembers"
              [customSort]="true" (sortFunction)="doCustomSort($event)"
              [resizableColumns]="true">

              <ng-template pTemplate="header">
                <tr>
                  <th class="uv-table-checkbox"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                  @for (col of cols; track col) {
                    <th pResizableColumn [pSortableColumn]="col.field">
                      {{col.header}}
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                  }
                  <th class="uv-table-button-column-1">
                    <!-- Action Buttons -->
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td class="uv-table-checkbox">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                  </td>
                  @for (col of cols; track col) {
                    <td>
                      <span class="uv-table-value">{{ rowData[col.field] }}</span>
                    </td>
                  }
                  <td class="uv-table-button-column-1">
                    <button type="button" class="btn btn-danger uv-first-table-button" title="Remove this device from the group"
                      (click)="onRemoveSingleDevice(rowData)">
                      <i class="pi pi-trash"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div style="width: 15%; padding: 0px 0px 0px 0px;">
            <button type="button" pButton style="width: 100%; margin-bottom: 5px;" (click)="onAddDevices()"
            label="Add Devices ..."></button>
            <button type="button" pButton style="width: 100%;" (click)="onRemoveSelectedDevices()"
              [disabled]="!selectedDeviceGroupMembers || selectedDeviceGroupMembers.length == 0"
            label="Remove Selected"></button>
          </div>
        </div>

      </p-tabPanel>
      <p-tabPanel header="Group Map Settings">
        <div style="margin-left: 25px; margin-right: 25px; margin-top: 10px; margin-bottom: 10px;">
          <map-settings [target]="target"></map-settings>
        </div>
      </p-tabPanel>
    </p-tabView>

    <device-preview header="Matching Primary Devices" [(visible)]="previewPrimVisible" [devices]="previewPrimDevices" [modal]="filterPreviewModal" (visibleChange)="onPreviewPrimVisibleChange($event)"></device-preview>

    <device-preview header="Matching Connected Devices" [(visible)]="previewConnVisible" [devices]="previewConnDevices" [modal]="filterPreviewModal" (visibleChange)="onPreviewConnVisibleChange($event)"></device-preview>

    <device-filter-selector [header]="'Select a Filter to Copy'" [(visible)]="copyPrimVisible"
      [filters]="copyPrimFilters" [min]="1" [max]="1"
      (onCancel)="onCopyPrimCancel()" (onOk)="onCopyPrimOk($event)">
    </device-filter-selector>

    <device-filter-selector [header]="'Select a Filter to Copy'" [(visible)]="copyConnVisible"
      [filters]="copyConnFilters" [min]="1" [max]="1"
      (onCancel)="onCopyConnCancel()" (onOk)="onCopyConnOk($event)">
    </device-filter-selector>

    <device-selector [header]="'Select Devices to Add'" [(visible)]="addDevicesVisible"
      [minDevices]="1" [maxDevices]="1000000"
      (onCancel)="onAddDevicesCancel()" (onOk)="onAddDevicesOk($event)">
    </device-selector>
  </form>
</div>